import { render, staticRenderFns } from "./DecompositionDetailsGraphic.vue?vue&type=template&id=24af4683"
import script from "./DecompositionDetailsGraphic.vue?vue&type=script&lang=js"
export * from "./DecompositionDetailsGraphic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports